import React from 'react'
import { Container } from 'react-bootstrap'

const ContentContainer = ({ children, fluid, className }) => {
  return (
    <Container className={className} fluid={fluid ? true : false}>
      {children}
    </Container>
  )
}

export default ContentContainer
